import * as React from 'react';
import axios from 'axios';
import Pagination from 'src/components/Shared/Pagination';

export default class LesImagesImport extends React.Component<any, any> {
  private URL = process.env.REACT_APP_IMAGES_URL;
  private URL_BASE = process.env.REACT_APP_IMAGES_BASE_URL;
  private BUCKET_PREFIX = process.env.REACT_APP_IMAGES_PREFIX || '';

  constructor(props: any) {
    super(props);

    this.state = {
      bucket: this.BUCKET_PREFIX + 'images-main',
      query: '',
      images: null,
      pages: 1,
    };

    this.request = this.request.bind(this);
  }

  public render() {
    const { isImageSelected, selectImages } = this.props;

    return (
      <div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>Bucket</label>
              <select
                className="form-control"
                onChange={(e) => {
                  const { value } = e.target;

                  this.setState({
                    bucket: value,
                  });
                }}
                value={this.state.bucket}
              >
                <option value="">Indistinto</option>
                <option value={this.BUCKET_PREFIX + "images-main"}>Principal</option>
                <option value={this.BUCKET_PREFIX + "images-misc"}>Miscelaneo</option>
                <option value={this.BUCKET_PREFIX + "images-activities"}>Actividades</option>
                <option value={this.BUCKET_PREFIX + "images-destinations"}>Destinos</option>
                <option value={this.BUCKET_PREFIX + "images-hotels"}>Hoteles</option>
              </select>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>Tags</label>
              <input
                type="text"
                className="form-control"
                onChange={(e) => {
                  const { value } = e.target;

                  this.setState({
                    query: value,
                  });
                }}
              />
              <p className="help-block">
                Separados por coma
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group pt-3">
              <button
                type="button"
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();

                  this.request({
                    page: 1,
                  });
                }}
              >
                Buscar
              </button>
            </div>
          </div>
        </div>
        <hr/>
        <div className="row">
          <div className="col">
            {
              Array.isArray(this.state.images) &&
              !this.state.images.length &&
              <div className="alert alert-info text-center">
                No se encontraron imagenes
              </div>
            }
            {
              Array.isArray(this.state.images) &&
              this.state.images.length &&
              <div className="row">
                {
                  this.state.images.map((image: any, i: number) => {
                    const src = `${this.URL_BASE}/r/${image.bucket}/300x300/${image.name}`;

                    return (
                      <div className="col-md-3 mb-3" key={i}>
                        <img
                          src={src}
                          style={{
                            maxWidth: '100%',
                            height: '100px',
                            cursor: 'pointer',
                            border: isImageSelected(image)
                              ? '4px solid blue'
                              : 'none',
                          }}
                          onClick={(e) => {
                            e.preventDefault();

                            selectImages([image]);
                          }}
                        />
                      </div>
                    );
                  })
                }
                <div className="col-md-12">
                  <Pagination pages={this.state.pages} onPageChange={this.request} />
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
  private async request({ page }: { page: number }) {
    const params: any = {
      limit: 12,
      skip: 12 * (page - 1),
      where: {},
    };

    if (this.state.bucket) {
      params.where.bucket = this.state.bucket;
    }

    if (this.state.query) {
      params.where.tags = {
        '$all': this.state.query.split(','),
      };
    }

    params.where = JSON.stringify(params.where);
    const { data, headers } = await axios({
      params,
      method: 'GET',
      url: `${this.URL}/api/images`,
    });

    this.setState({
      images: data,
      pages: Math.ceil(parseInt(headers['x-total-count'], 10) / 12),
    });
  }
}



// WEBPACK FOOTER //
// ./src/containers/Shared/Images/import.tsx